import React from 'react';

import { Button, type SxProps } from '@mui/material';

import Link from './Link';

type ButtonLinkProps = Omit<Parameters<typeof Button>[0], 'href' | 'component'>;

type Props = ButtonLinkProps & {
  href: string;
  linkSx?: SxProps;
  target?: string;
};

const ButtonLink = React.forwardRef<HTMLAnchorElement, Props>(function ButtonLink(
  { href, linkSx, target, ...props },
  ref
) {
  return (
    <Link ref={ref} href={href} sx={linkSx} color="inherit" target={target}>
      <Button {...props} />
    </Link>
  );
});

export default ButtonLink;
